import React from "react";
import CareerSkillsSection from "../Shared/CareerSkillsSection";

const ShortCoursesCareerSkills = () => {
  return (
    <CareerSkillsSection
      title="SHORT COURSES SKILLS? CHECK."
      paragraphs={[
        `In Short Courses at JRIIT, you'll get focused education on specific skills that are vital for career advancement — targeted expertise in various technical and professional areas. These are the skills that employers say make JRIIT Short Course graduates stand out. Our Short Courses program offers flexible learning options with certificates upon completion.`,

        `Why? We emphasize hands-on learning instead of traditional letter grades. In every course, you'll receive detailed feedback on your technical strengths and where you can improve, giving you a more complete picture of your growth.`,

        `Discover our Short Courses below and unlock the skills to shape your future.`,
      ]}
    />
  );
};

export default ShortCoursesCareerSkills;
